enum MediaTypes {
	video,
	audio,
	image,
	stills,
	user,
	thumbnail,
	folder,
	subtitles,
	p2,
	document,
	order,
	hls,
	transcoderIndex,
	imagenwebResources,
	social,
	live,
	unknown = 15 // unknown and live are both type 15 as stated in MediaTypes.php
}

namespace MediaTypes {

	/**
	 * Returns true if the type is temporal
	 * @param mediaType
	 */
	export function isTemporal(mediaType: MediaTypes): boolean {
		return mediaType === MediaTypes.audio || mediaType === MediaTypes.video;
	}

    /**
     * Returns true if the media type is downloadable
     * @param mediaType
     */
    export function isMediaDownloadable(mediaType: string): boolean {
        const downloadableTypes = [
            MediaTypes[MediaTypes.audio],
            MediaTypes[MediaTypes.video],
            MediaTypes[MediaTypes.image],
            MediaTypes[MediaTypes.document]
        ];
        return downloadableTypes.indexOf(mediaType.toLowerCase()) !== -1;
    }
}

enum MediaState {
	new,
	processing,
	archived,
	failed,
	live,
	unknown
}

enum JobState {
	New,
	Waiting,
	Paused,
	Start,
	Completed,
	Processing,
	Retrying,
	Failed,
	STATE_INVALID_ELEMENT,
	STATE_INVALID_INPUTS,
	STATE_ADDJOB_ERROR,
	STATE_PROGRESS_TIMEOUT,
	Cancelled,
	Deleted
}